import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { MembershipService } from '../../services/membership/membership.service';
import { AuthService } from '../../services/auth';
import { of } from 'rxjs';

export const membershipGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const membershipService = inject(MembershipService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Skip membership validation for system administrators
  if (authService.isSystemAdmin()) {
    return of(true);
  }

  // Skip guard if we're already on the billing page to avoid infinite redirects
  const isBillingPage = route.url.some(segment => segment.path === 'billing') ||
                        route.url.join('/').includes('billing');
  if (isBillingPage) {
    return of(true);
  }

  // Get current membership status from cache only (should always be available at this point)
  const currentStatus = membershipService.getCurrentMembershipStatus();

  if (currentStatus?.isExpired) {
    console.error('Tu período de prueba ha expirado. Por favor, suscríbete para continuar.');
    router.navigate(['/settings/billing'], { replaceUrl: true });
    return of(false);
  }

  // If no status loaded yet, allow access (should not happen as auth guard handles initial check)
  return of(true);
};
